import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {
  normalizeStyles,
  typographyStyles,
} from '@webs/components-library/theming';


@customElement('webs-card-stats')
export class CardStats extends LitElement {

  static styles = [
    normalizeStyles,
    typographyStyles,
    css`
      .m-card-stats {
        width: 100%
      }

      .m-card-stats .card {
        border-radius: 0.5rem;
        padding: 1.8rem;
        width: 100%
      }

      .m-card-stats .light {
        background-color: var(--color-light-grey);
      }

      .m-card-stats .gradient-orange {
        background: linear-gradient(216.4deg, #FF8A00 22.12%, #FF00FF 110.96%);
      }
      ::slotted(*:nth-child(n+2)) {
        display: block;
        margin-top: 1.4rem;
        padding-top: 1.4rem;
      }

      .card ::slotted(*:nth-child(n+2)) {
        border-top: 1px solid var(--color-dark-grey);
      }

      .gradient-orange ::slotted(*:nth-child(n+2)) {
        border-top: 1px solid var(--color-light-grey);
      }

      @media only screen and (max-width: 767px) {
        .m-card-stats {
          max-width: 450px;
          margin: 1rem auto;
        }
      }

    `,
  ];

  @property({attribute: 'is-gradient-background', type: Boolean})
  isGradientBackground: boolean;

  protected render(): unknown {
    return html`
    <div class="m-card-stats">
      <div class="card ${this.isGradientBackground ? 'gradient-orange':'light'}">
        <slot name="statistics"></slot>
      </div>
    </div>
    `;
  }

}
